export const GET_DOCUMENTS_ABORTED = 'GET_DOCUMENTS_ABORTED';
export const GET_DOCUMENTS_REQUESTED = 'GET_DOCUMENTS_REQUESTED';
export const GET_DOCUMENTS_COMPLETED = 'GET_DOCUMENTS_COMPLETED';
export const GET_DOCUMENTS_FAILED = 'GET_DOCUMENTS_FAILED';

export const SET_DOCUMENTS_REDIRECTROUTE_REQUESTED =
  'SET_DOCUMENTS_REDIRECTROUTE_REQUESTED';
export const SET_DOCUMENTS_REDIRECTROUTE_COMPLETED =
  'SET_DOCUMENTS_REDIRECTROUTE_COMPLETED';
export const SET_DOCUMENTS_REDIRECTROUTE_FAILED =
  'SET_DOCUMENTS_REDIRECTROUTE_FAILED';
export const RESET_DOCUMENTS_REDIRECTROUTE_REQUESTED =
  'RESET_DOCUMENTS_REDIRECTROUTE_REQUESTED';
export const RESET_DOCUMENTS_REDIRECTROUTE_COMPLETED =
  'RESET_DOCUMENTS_REDIRECTROUTE_COMPLETED';
export const RESET_DOCUMENTS_REDIRECTROUTE_FAILED =
  'RESET_DOCUMENTS_REDIRECTROUTE_FAILED';

export const GET_ADVISERDOCUMENTS_ABORTED = 'GET_ADVISERDOCUMENTS_ABORTED';
export const GET_ADVISERDOCUMENTS_REQUESTED = 'GET_ADVISERDOCUMENTS_REQUESTED';
export const GET_ADVISERDOCUMENTS_COMPLETED = 'GET_ADVISERDOCUMENTS_COMPLETED';
export const GET_ADVISERDOCUMENTS_FAILED = 'GET_ADVISERDOCUMENTS_FAILED';

export const RESET_DOCUMENTS_REQUESTED = 'RESET_DOCUMENTS_REQUESTED';
export const RESET_DOCUMENTS_COMPLETED = 'RESET_DOCUMENTS_COMPLETED';
export const DOWNLOAD_DOCUMENT_REQUESTED = 'DOWNLOAD_DOCUMENT_REQUESTED';
export const DOWNLOAD_DOCUMENT_COMPLETED = 'DOWNLOAD_DOCUMENT_COMPLETED';
export const DOWNLOAD_DOCUMENT_FAILED = 'DOWNLOAD_DOCUMENT_FAILED';
export const VIEW_DOCUMENT_REQUESTED = 'VIEW_DOCUMENT_REQUESTED';
export const VIEW_DOCUMENT_COMPLETED = 'VIEW_DOCUMENT_COMPLETED';
export const VIEW_DOCUMENT_FAILED = 'VIEW_DOCUMENT_FAILED';
export const RESET_VIEW_DOCUMENT_REQUESTED = 'RESET_VIEW_DOCUMENT_REQUESTED';
export const RESET_VIEW_DOCUMENT_COMPLETED = 'RESET_VIEW_DOCUMENT_COMPLETED';
export const RESET_VIEW_DOCUMENT_FAILED = 'RESET_VIEW_DOCUMENT_FAILED';

export const GET_IPADDRESS_REQUESTED = 'GET_IPADDRESS_REQUESTED';
export const GET_IPADDRESS_COMPLETED = 'GET_IPADDRESS_COMPLETED';
export const GET_IPADDRESS_FAILED = 'GET_IPADDRESS_FAILED';

export const GET_SHAREPOINTDOCUMENTS_REQUESTED =
  'GET_SHAREPOINTDOCUMENTS_REQUESTED';
export const GET_SHAREPOINTDOCUMENTS_COMPLETED =
  'GET_SHAREPOINTDOCUMENTS_COMPLETED';
export const GET_SHAREPOINTDOCUMENTS_FAILED = 'GET_SHAREPOINTDOCUMENTS_FAILED';
export const GET_SHAREPOINTDOCUMENTS_ABORTED =
  'GET_SHAREPOINTDOCUMENTS_ABORTED';

export const VIEW_SIGNEDDOCUMENT_REQUESTED = 'VIEW_SIGNEDDOCUMENT_REQUESTED';
export const VIEW_SIGNEDDOCUMENT_COMPLETED = 'VIEW_SIGNEDDOCUMENT_COMPLETED';
export const VIEW_SIGNEDDOCUMENT_FAILED = 'VIEW_SIGNEDDOCUMENT_FAILED';
export const VIEW_SIGNEDDOCUMENT_ABORTED = 'VIEW_SIGNEDDOCUMENT_ABORTED';
